export default __webpack_public_path__ + "static/media/O_Mats_Runners.8b2d1144.jpg";